export default __webpack_public_path__ + "static/media/nus_enterprise.80d77efd.png";